(() => {
const $9fe2d82f5fed61b6$var$videos = document.querySelectorAll(".gallery__play");
if ($9fe2d82f5fed61b6$var$videos) $9fe2d82f5fed61b6$var$videos.forEach((video)=>{
    video.addEventListener("click", ()=>{
        const targetVideo = document.getElementById(video.dataset.video);
        targetVideo.play();
        targetVideo.controls = true;
        video.style.display = "none";
    });
});
// ________________________________________
const $9fe2d82f5fed61b6$var$slider = document.querySelectorAll(".slider");
$9fe2d82f5fed61b6$var$slider?.forEach((slider)=>{
    const sliderWrapper = slider.querySelector(".slider__wrapper");
    const sliderContainer = slider.querySelector(".slider__container");
    const sliderNav = slider.querySelector(".slider__nav");
    let slidePrev;
    let slideNext;
    const itemWidth = sliderContainer?.querySelector(".slider__item")?.offsetWidth;
    if (sliderNav) {
        slidePrev = sliderNav.querySelector(".slider__prev");
        slideNext = sliderNav.querySelector(".slider__next");
    }
    const watchNavState = ()=>{
        if (sliderContainer.scrollLeft === 0) slidePrev.classList.remove("active");
        else slidePrev.classList.add("active");
        if (sliderContainer.scrollLeft + sliderWrapper.offsetWidth >= sliderContainer.scrollWidth) slideNext.classList.remove("active");
        else slideNext.classList.add("active");
    };
    watchNavState();
    if (slideNext) slideNext.addEventListener("click", ()=>{
        watchNavState();
        if (sliderContainer.scrollLeft + sliderWrapper.offsetWidth < sliderContainer.scrollWidth) sliderContainer.scrollLeft += itemWidth * 1.5;
    });
    if (slidePrev) slidePrev.addEventListener("click", ()=>{
        watchNavState();
        if (sliderContainer.scrollLeft - sliderWrapper.offsetWidth < sliderContainer.scrollWidth) sliderContainer.scrollLeft -= itemWidth * 1.5;
    });
});
//--------------------Intersection observer
const $9fe2d82f5fed61b6$var$animateTarget = document.querySelectorAll(".animate-observe");
const $9fe2d82f5fed61b6$var$options = {};
const $9fe2d82f5fed61b6$var$animateTargetObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) entry.target.classList.add("animate--reveal");
    });
}, $9fe2d82f5fed61b6$var$options);
$9fe2d82f5fed61b6$var$animateTarget.forEach(function(animateTarget) {
    $9fe2d82f5fed61b6$var$animateTargetObserver.observe(animateTarget);
});


if (window) {
    const nav = document.querySelector("#nav");
    const navToggle = document.querySelector("#nav-toggle");
    const navInner = document.querySelector("#nav-inner");
    const isDesktop = window.innerWidth > 767;
    const navItemSelector = isDesktop ? ".nav__list--root > .nav__item" : ".nav__item";
    const closeSubmenu = async ()=>{
        nav.querySelectorAll(".nav__submenu--open").forEach((openSubnav)=>{
            openSubnav.classList.remove("nav__submenu--open");
        });
    };
    if (navToggle) navToggle.addEventListener("click", ()=>{
        navInner.classList.toggle("nav__inner--open");
        navToggle.classList.toggle("nav__toggle--active");
    });
    //Check all nav items
    if (navInner) navInner.querySelectorAll(navItemSelector).forEach((item)=>{
        const navLink = item.querySelector("a");
        const navSubmenu = item.querySelector(".nav__submenu");
        //Add sublink class
        if (navSubmenu) {
            //Append Submenu Link
            const subMenuClose = document.createElement("div");
            subMenuClose.classList.add("nav__submenu-close");
            // subMenuClose.innerHTML = isDesktop ? "Close" : "Back";
            const subMenuHeadline = document.createElement(navLink.href ? "a" : "div");
            subMenuHeadline.classList.add("nav__submenu-headline");
            subMenuHeadline.innerHTML = navLink.innerHTML;
            subMenuHeadline.href = navLink.href;
            navSubmenu.prepend(subMenuHeadline);
            navSubmenu.prepend(subMenuClose);
            navSubmenu.querySelector(".nav__submenu-close").addEventListener("click", ()=>{
                if (isDesktop) closeSubmenu();
                else navSubmenu.classList.remove("nav__submenu--open");
            });
            item.classList.add("nav__item--has-submenu");
            navLink.addEventListener("click", (e)=>{
                e.preventDefault();
                if (isDesktop) closeSubmenu();
                navSubmenu.classList.add("nav__submenu--open");
                if (!isDesktop) {
                    console.log(navSubmenu.closest(".nav__submenu"));
                    navSubmenu.closest(".nav__submenu").classList.add("nav__submenu--open");
                }
            });
        }
        //set active class
        if (navLink.pathname === window.location.pathname) item.classList.add("nav__item--active");
    });
}


const $0c5b6944dc9594db$var$modals = document.querySelectorAll("[data-modal]");
$0c5b6944dc9594db$var$modals.forEach((modal)=>{
    modal.addEventListener("click", ()=>{
        console.dir(modal.attributes["data-modal"].value);
        const target = document.querySelector(`#${modal.attributes["data-modal"].value}`);
        target.classList.add("active");
        const close = target.querySelectorAll("[data-modal-close]");
        close.forEach((item)=>{
            item.addEventListener("click", ()=>{
                target.classList.remove("active");
            });
        });
    });
});






})();
//# sourceMappingURL=main.js.map
